export default __webpack_public_path__ + "static/media/arrowLeft.fa5386e3.svg";